<template>
  <div>
    <div class="content-title">
      <span>充值</span>
      <el-button @click="back" class="fr">返回</el-button>
    </div>
    <div class="content-tool" style="width: 500px;">
      <el-form :model="addrecharge" label-width="120px">
        <el-form-item label="付款人：">
          <div>{{ addrecharge.payName }}</div>
        </el-form-item>
        <el-form-item label="付款账户：">
          <div>{{ addrecharge.payAccount }}</div>
        </el-form-item>
        <el-form-item label="收款人：">
          <div>{{ addrecharge.recvName }}</div>
        </el-form-item>
        <el-form-item label="收款账户：">
          <div>{{ addrecharge.recvAccount }}</div>
        </el-form-item>
        <el-form-item label="转账金额：">
          <div>{{ addrecharge.money }}</div>
        </el-form-item>
        <el-form-item label="付款日期：">
          <div>{{ addrecharge.payDate }}</div>
        </el-form-item>
        <el-form-item label="上传回单：">
          <div class="img-box" v-if="addrecharge.fileUrl != null">
            <el-image
              :src="addrecharge.fileUrl"
              style="width: 100px; height: 100px"
              :preview-src-list="fileUrlList"
            ></el-image>
          </div>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        @click="confirmButton(1)"
        style="margin-left: 30px;"
        >审核通过</el-button
      >
      <el-button
        type="primary"
        @click="confirmButton(0)"
        style="margin-left: 20px;"
        >审核不通过</el-button
      >
    </div>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'auditrecharge',
  data() {
    return {
      addrecharge: {
        rechargeId: null,
        payName: null,
        payAccount: null,
        recvName: null,
        recvAccount: null,
        money: 0.0,
        fileUrl: null,
      },
      fileUrlList: [],
    };
  },
  mounted() {
    this.addrecharge.rechargeId = this.$route.query.rechargeId;
    this.fetchRechargeDetail();
  },
  methods: {
    fetchRechargeDetail() {
      api
        .fetchRechargeDetail({
          params: {
            params: {
              rechargeId: this.addrecharge.rechargeId,
            },
          },
        })
        .then((res) => {
          this.addrecharge = res;
          this.fileUrlList = [];
          this.fileUrlList.push(res.fileUrl);
          console.log(this.fileUrlList);
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    confirmButton(rechargeStatus) {
      this.$confirm(
        '确认审核'.concat(rechargeStatus === 1 ? '通过 ？' : '不通过 ？'),
        '',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(() => {
        this.auditRecharge(rechargeStatus);
      });
    },
    auditRecharge(rechargeStatus) {
      api
        .auditRecharge({
          params: {
            params: {
              rechargeStatus,
              rechargeId: this.addrecharge.rechargeId,
            },
          },
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '审核提交成功',
          });
          this.$router.go(-1);
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.content-tool {
  background: #fff;
  font-size: 16px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.img-box {
  position: relative;
  display: block;
  font-size: 0;
  width: 100px;
  height: 100px;
  margin: 15px 10px 10px 0px;
  img {
    display: block;
    width: 80px;
    height: 80px;
    object-fit: cover;
  }
  i {
    position: absolute;
    width: 25px;
    height: 20px;
    font-size: 25px;
    right: -12px;
    top: -12px;
    background: #fff;
    cursor: pointer;
    color: #999;
    border-radius: 50%;
    text-align: center;
    line-height: 25px;
  }
}
.content-tool--operate {
  padding: 0px 17px 20px 17px;
  margin: 0px 20px 20px 20px;
}
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>

<style scoped>
.el-form .el-form-item {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/auditrecharge.vue